<script setup>
import {useReportOutput} from "@/components/report/outputs/useReportOutput";

const props = defineProps({
  value: [String, Object]
})

const {v, extra} = useReportOutput(props)

</script>

<template>
  <div v-if="$store.state.printing">{{ v }}</div>
  <b-link v-else-if="extra?.gli" @click="global_lookup(extra.gli, true)">{{ v }}</b-link>
  <b-link v-else @click="global_lookup(v, true)">{{ v }}</b-link>
</template>

<style scoped>

</style>